import React from 'react'

export default function Albums() {
  return (
    <div className="screen-game">
      <h1>Albums</h1>
      <div style={{backgroundPosition : 'center', backgroundSize : 'cover'}}>
          <img src="./img/albums.jpg" alt="..." />          
      </div>
    </div>
  )
}
